module.exports = __webpack_public_path__ + "static/media/Atomo_tablet.4e435457.png";